export default "__VITE_ASSET__CIlA2KWS__"